let sessionSyncInProgress = false;

export function setSessionSyncInProgress(active) {
  sessionSyncInProgress = Boolean(active);
}

export function isSessionSyncInProgress() {
  return sessionSyncInProgress;
}
